import { Typography, styled } from "@material-ui/core";

export const SectionTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.other.black500,
  fontSize: '24px',
  lineHeight: '29px',
  display: 'block',
  marginBottom: '1rem',
}));